import { PRODUCTS_TABS, ProductsTab } from '../constants/productsTabs';

/**
 * Resolves the `?tab=` query param to a tab that the products page can render.
 *
 * Unknown values fall back to "sourcing" instead of rendering nothing. That
 * also covers the former "drafts" tab, which is now the "Incomplete" section
 * of the "Sourcing" tab, so old links and bookmarks keep working.
 */
const resolveProductsTab = (tab: string | null): ProductsTab => {
  const match = PRODUCTS_TABS.find(
    (candidate) => candidate === tab?.toLowerCase()
  );

  return match ?? 'sourcing';
};

export default resolveProductsTab;
